// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/forms/fields/Multiline/index.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/forms/fields/Multiline/index.tsx");
  import.meta.hot.lastModified = "1732036225881.7";
}
// REMIX HMR END

import { clsx } from "clsx";
import { forwardRef } from "react";
export const Multiline = forwardRef(_c = ({
  className,
  formRegister,
  ...props
}, ref) => <textarea ref={ref} rows={5} {...formRegister} className={clsx("bg-neutral-50 rounded-lg border border-primary-300 py-4 px-3 text-neutral-600", "disabled:cursor-not-allowed disabled:bg-neutral-50 disabled:text-neutral-300", "focus:border-primary-600 focus:outline-none focus:ring-primary-600 focus:ring-offset-primary-600", "active:border-primary-600 hover:border-primary-600", "placeholder:text-neutral-600 focus:placeholder:opacity-0", "aria-[invalid=true]:border-error-600 aria-[invalid=true]:ring-error-600 aria-[invalid=true]:ring-offset-error-600", className)} {...props} />);
_c2 = Multiline;
var _c, _c2;
$RefreshReg$(_c, "Multiline$forwardRef");
$RefreshReg$(_c2, "Multiline");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;